import React,{useRef,useState} from 'react';
import queryString from "query-string";

import styles from './add-edit-product.scss';
import AuditButtonComponent from './AuditButtonComponent';
import Button from 'jd-library/Button';
import {useHistory} from "react-router-dom";
import {identifyAuditFlow} from "../../utills";
import Popover from 'jd-library/Popover';
import ContractorSourceDetail from './ContractorSourceDetail';
import ConnectedNumber from '../../common/connectedNumber/ConnectedNumber';

const JdRepresentativeProfile = props => {
    const[sourceDetail,toggleSourceDetail] = useState(false);
    const [connectedNumModal, setconnectedNumModal] = useState(false)
    const profileObject = props?.session?.profileObject;
    let copytext = useRef(null);
    let history = useHistory();
    let parentRef = React.useRef(null);
    const flowCheck = identifyAuditFlow({checkType: true});
    const isShowConnectedNumberButton = props?.isShowConnectedNumberButton;
    const CORRECTOR = props.session.user.loggedUser?.subType == "CORRECTOR"
    const copyCodeToClipboard = () =>{
		copytext.current.select();
		document.execCommand("copy");
		props.showToastMessage({
			showToastMessage: true,
			message: 'Doc ID Copied',
			duration: 5000
		});
    }
    let displayDocId = '';
    if(props.session && props.session.docId){
        displayDocId = props.session.docId;
    }
    const skipContract = () => {
        props.updateAuditDocModal({
            from: "skipContract"
        });
    };

    const websiteRedirect = (e,url) => {
        e.stopPropagation();
        window.open(url, "_blank");
    }


    return (<>
            <div className={styles['data-header']}>{props.session && props.session.companyName}</div>
                <div className={styles['data-address']}>{props.session && (props.session.city+'-'+props.session.state)}</div>
                <div className={styles['data-docid-holder']}>
                    <div className={styles['display-data-docid']}>{displayDocId}</div>
                    <textarea className={styles['data-docid']} ref = {copytext} readonly="readonly" value = {displayDocId}></textarea>
                    <div className={styles['product-id-copy-holder']} onClick={copyCodeToClipboard}>
                        <span className={styles['product-id-copy-icon']+" icon-Copy"}></span>
                        COPY
                    </div>
                </div>
                {!CORRECTOR && props.showTotalCount && props.totalCount && !props.isAddProduct && (<div className={styles['data-total-count']}>{`Total ${(profileObject?.PluralLabelWithSpace)} for Audit: `+props.totalCount}</div>)
                }
                <div className='item-btns'>
                    {(!props.dontShowViewButton && !props.isAddProduct) && <div className='common-btn'>
                        <Button
                        variant="default"
                        block
                         style={ {width: (!props.ownerConnectedMobile) ? '100%' : ''}}
                        clickHandler = {() => {
                            const search = identifyAuditFlow({checkType: true});
                            const isProductSearch = queryString.parse(window.location.search);
                            if(search.searchAudit && !(isProductSearch?.searchBy && isProductSearch?.searchBy?.toLowerCase()=='productid')) {
                                window.history.back();
                            } else {
                                let url = `/products?docId=${displayDocId}&searchBy=docId&showResultBy=contracts&useAuditApi=true&isAuditUrl=true&isSpecialContract=true&fromFetchFlow=true`;
                                if(search.loadedInIframe) {
                                    url += '&loadedInIframe=true';
                                }
                                history.push(url);
                            }
                        }}
                    >
                        {`View All ${((profileObject?.PluralLabelWithSpace == 'Products / Services') ? 'Products' : profileObject?.PluralLabelWithSpace)}`}
                    </Button>
                </div>}
                    {
                        isShowConnectedNumberButton ?
                            <div className='common-btn'>
                                <Button
                                    variant="default"
                                    disabled={props?.ownerConnectedMobile?.length == 0 ? true : false}
                                    style={ { opacity: props?.ownerConnectedMobile?.length == 0 ?  '0.5' : '',color: props?.ownerConnectedMobile?.length == 0 ? '#0086FF' : '', borderColor: props?.ownerConnectedMobile?.length == 0 ? '#0086FF' : ''}}

                                    onClick ={(event) => {
                                        setconnectedNumModal(true)
                                    }}
                                >
                                    Connected Numbers
                                </Button>
                            </div>
                        : null
                    }
                </div>
                {connectedNumModal && <ConnectedNumber data={props.ownerConnectedMobile || []} isAuditor={true} docId={displayDocId} onHidden={()=>setconnectedNumModal(false)}/>}
                {!props.dontShowButtons && <AuditButtonComponent btnArr = {props.auditBtnArray} AuditWebsiteBtn={props.AuditWebsiteBtn} fromListingPage = {props.fromListingPage}></AuditButtonComponent>}
                {(!props.dontShowButtons && props.contractorSourceList && props.contractorSourceList.length ) ? (<div className = {'source-detail-btn'}>
                    <Button
                        variant="default"
                        block
                        clickHandler = {() => {
                            toggleSourceDetail(true);
                        }}
                    >
                        {props.isContractorSoruceLbl} Source Details
                    </Button>
                </div>) : null}
                {(flowCheck.fetchNextAudit && !flowCheck.searchAudit && props.from != 'skipContract' && props.belongsTo == 'editPage' && props.type == 'furlough' && <div className = {styles['view-all-btn']}><Button
                    variant="default"
                    block
                    clickHandler = {skipContract}
                >Skip Contract For Audit</Button></div>)}
                {sourceDetail ? <ContractorSourceDetail
                    contractorSourceList = {props.contractorSourceList}
                    onHidden = {() => {
                        toggleSourceDetail(false);
                    }}
                    isContractorSourcev1 = {props.isContractorSourcev1}
                    websiteLink = {props.websiteLink}
                >
                </ContractorSourceDetail> : null}
        </>);
};


export default JdRepresentativeProfile;